var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigureYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.25C9.79565 4.25 10.5587 4.56607 11.1213 5.12868C11.6839 5.69129 12 6.45435 12 7.25C12 8.04565 11.6839 8.80871 11.1213 9.37132C10.5587 9.93393 9.79565 10.25 9 10.25C8.20435 10.25 7.44129 9.93393 6.87868 9.37132C6.31607 8.80871 6 8.04565 6 7.25C6 6.45435 6.31607 5.69129 6.87868 5.12868C7.44129 4.56607 8.20435 4.25 9 4.25Z",
    fill: "#F48503"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.75,
    width: 17,
    height: 17,
    rx: 2.5,
    stroke: "#F48503"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.75C16 16.276 16 17.25 16 17.25C11 17.25 8 17.25 2.00001 17.25C2.00001 17.25 2 16.276 2 15.75C2 13.2647 5.13401 11.25 9 11.25C12.866 11.25 16 13.2647 16 15.75Z",
    fill: "#F48503"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureYellow);
export default __webpack_public_path__ + "static/media/figure_yellow.6976439131b74a5157907619c6a28b9b.svg";
export { ForwardRef as ReactComponent };